import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';
import { Subscription } from 'rxjs';
import { DkHeaderComponent } from './dk-header/dk-header.component';
import { DkSideNavigationMenuComponent } from './dk-side-navigation-menu/dk-side-navigation-menu.component';
import { ScreenService } from '../../services/screen.service';
import { DkNavService } from '../../services/dk-nav.service';import {
  DxTreeViewModule, DxTreeViewComponent, DxListModule, DxContextMenuModule, DxContextMenuComponent,DxDrawerModule, DxScrollViewComponent
} from 'devextreme-angular';
import { OpenedStateMode, RevealMode } from 'devextreme/ui/drawer';
import { GisMapService } from '../../services/gis-map.service';
import { environment } from '../../services/app-settings.service';
import { DkSideNotificationMenuComponent } from './dk-side-notification-menu/dk-side-notification-menu.component';
import { RealtimeService } from '../../services/realtime.service';
import { TamEkranService } from '../../services/tam-ekran.service';
import { CalismaDuzeniService } from '../../services/calisma-duzeni.service';
@Component({
  selector: 'dk-main',
  standalone: true,
  imports: [
    CommonModule,
    DxDrawerModule,
    DkHeaderComponent,
    DkSideNavigationMenuComponent,
    RouterModule,
    DxTreeViewModule, DxListModule, DxContextMenuModule,
    DkSideNotificationMenuComponent
  ],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView: DxTreeViewComponent;

@ViewChild(DxContextMenuComponent, { static: false }) contextMenu: DxContextMenuComponent;
  @ViewChild(DxScrollViewComponent, { static: true })
  scrollView!: DxScrollViewComponent;

  @Input()
  title!: string;

  selectedRoute = '';

  // eski hâli (16.10.2026, menü durumu "Kompakt" anahtarı için CalismaDuzeniService'e bildirilir):
  // menuOpened!: boolean;
  private _menuOpened!: boolean;
  get menuOpened(): boolean {
    return this._menuOpened;
  }
  set menuOpened(acik: boolean) {
    this._menuOpened = acik;
    this.calismaDuzeni.menuDurumu(!!acik);
  }
  notifOpened:boolean = window.innerWidth >= 1024;

  temporaryMenuOpened = false;

  menuMode: OpenedStateMode = 'shrink';

  menuRevealMode: RevealMode = 'expand';

  minMenuSize = 0;

  shaderEnabled = false;

  routerSubscription: Subscription;

  screenSubscription!: Subscription;

  private kompaktAbonelik?: Subscription;

  constructor(
    private screen: ScreenService,
    private router: Router,
    private service: DkNavService,
    private gisMapService: GisMapService,
    private realtime: RealtimeService,
    public tamEkran: TamEkranService,
    private calismaDuzeni: CalismaDuzeniService
  ) {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.selectedRoute = event.urlAfterRedirects.split('?')[0];
      }
    });
  }  
  @HostListener('window:resize', [])
  onResize() {
    this.notifOpened = window.innerWidth >= 1024;
  }
  ngOnInit() {
    this.service.getMenu(0);
    // DKM-5158 Cedric: eski hâli — getFav(true) ilk favoriyi (menuList[0]) açılışta otomatik sekme olarak açıyordu
    // this.service.getFav(true);
    // DKM-5158: açılışta favori otomatik açılmaz; favoriler yalnız menüde listelenir
    this.service.getFav(false);
    // eski hâli (16.10.2026):
    // this.menuOpened = this.screen.sizes['screen-large'];
    // Son oturumda "Kompakt" düzen açıksa menü daraltılmış başlar
    this.menuOpened = this.screen.sizes['screen-large'] && !this.calismaDuzeni.kompaktKayitli;
    this.kompaktAbonelik = this.calismaDuzeni.menuIstegi$.subscribe((acik) => {
      this.temporaryMenuOpened = false;
      this.menuOpened = acik;
    });
    this.screenSubscription = this.screen.changed.subscribe(() =>
      this.updateDrawer()
    );

    this.updateDrawer();
    this.preloadGisMap();
    this.realtime.baslat();
  }

  /** gisPreload açıksa harita uygulamasını, ana sayfa açıldıktan sonra boşta kalınca arka planda yükler. */
  private preloadGisMap() {
    if (!environment.gisPreload) return;
    const ric = (window as any).requestIdleCallback;
    if (typeof ric === 'function') ric(() => this.gisMapService.preload(), { timeout: 10000 });
    else setTimeout(() => this.gisMapService.preload(), 3000);
  }

  ngOnDestroy(): void {
    this.realtime.durdur();
    this.routerSubscription.unsubscribe();
    this.screenSubscription.unsubscribe();
    this.kompaktAbonelik?.unsubscribe();
  }



  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 48;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event: DxTreeViewTypes.ItemClickEvent) {
    const path = (event.itemData as any).path;
    const pointerEvent = event.event;
    if (path && this.menuOpened) {
      if (event.node?.selected) {
        pointerEvent?.preventDefault();
      }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent?.stopPropagation();
      }
    } else {
      pointerEvent?.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}
